<app-loading *ngIf="!contentReady"></app-loading>

<div class="container mb-4" *ngIf="contentReady">
  <div class="row additem-content">
    <h2 class="additemhead">{{ 'New client' | translate }}</h2>

    <form class="form" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="d-flex flex-column flex-sm-row justify-content-center">
        <div class="col-12 form-container">

          <div class="form-group">
            <input class="input" type="text" formControlName="name_en" placeholder="{{ 'Name' | translate }}" />
          </div>

          <div class="form-group">
            <input class="input" type="text" formControlName="name_ar" placeholder="{{ 'NameAr' | translate }}" />
          </div>

          <div class="form-group">
            <input class="input" type="text" formControlName="job" placeholder="{{ 'job title' | translate }}" />
          </div>

          <div class="form-group">
            <input class="input" type="text" formControlName="address" placeholder="{{ 'address' | translate }}" />
          </div>
 @if(!isUpdatePage){
          <div class="form-group">
            <input class="input" type="text" formControlName="phone_number"
              placeholder="{{ 'Phone Number' | translate }}" />
          </div>

          <div class="form-group">
            <input class="input" type="text" formControlName="another_phone"
              placeholder="{{ 'Another Phone Number' | translate }}" />
          </div>
        }
          <!-- مثال على تواريخ -->
          <div class="form-group">
            <input class="input" type="text" [placeholder]="'internet date' | translate" (focus)="type='date'"
              (blur)="!data.get('internet_date')?.value && (type='text')" [attr.type]="type"
              formControlName="internet_date" />
          </div>

          <!-- باقي الفيلدات -->
          <div class="form-group">
            <input class="input" type="text" formControlName="passport_number"
              placeholder="{{ 'Passport' | translate }}" />
          </div>


          <div class="form-group">
            <input class="input" type="text" formControlName="request_number"
              placeholder="{{ 'Request Number' | translate }}" />
          </div>

          <div class="form-group">
            <input class="input" type="text" formControlName="visa_number"
              placeholder="{{ 'Visa Number' | translate }}" />
          </div>

          <div class="form-group">
            <input class="input" type="text" formControlName="record_number"
              placeholder="{{ 'Record Number' | translate }}" />
          </div>

          <div class="form-group">
            <input class="input" type="text" formControlName="foreign_agency"
              placeholder="{{ 'Foreign Foundation' | translate }}" />
          </div>
          <div class="form-group">
            <input class="input" type="text" formControlName="worker_embassy"
              placeholder="{{ 'Worker Embassy' | translate }}" />
          </div>
          <div class="form-group">
            <select class="input" formControlName="visa_type">
              <option value="0">زيارة فرست جروب</option>
              <option value="1">فيزا فرست جروب</option>
                 <option value="2">فيزا عمل</option>
            </select>
          </div>
          <div class="form-group">
            <input class="input" type="text" formControlName="representative" placeholder="المندوب" />
          </div>


          <ng-container *ngIf="accounttype == 1 || accounttype == 2">

            <!-- Payment Method -->
            <div class="form-group">
              <select class="input" formControlName="payment_method">
                <option value="0"> كاش</option>
                <option value="1"> انتساباي</option>
                <option value="2"> محفظة الالكترونية</option>
                <option value="3"> تحويل بنكي</option>
              </select>
            </div>

            <!-- Visa Type -->


            <!-- Payment Status -->
            <div class="form-group">
              <select class="input" formControlName="payment_status">
                <option value="0">قيد الانتظار</option>
                <option value="1">مكتمل جزئي</option>
                <option value="2">مكتمل</option>
                <option value="3">مرفوض</option>
              </select>
            </div>


            <div class="form-group">
              <input class="input" type="number" formControlName="paid" placeholder="المدفوع" />
            </div>

            <!-- Remaining -->
            <div class="form-group">
              <input class="input" type="number" formControlName="remaining" placeholder="الباقي" />
            </div>
          </ng-container>


          <div class="form-group">
            <label><input type="checkbox" formControlName="lab" />{{ 'Lab' | translate }}</label>
            <label><input type="checkbox" formControlName="hospital" />{{ 'Hospital' | translate }}</label>
            <label><input type="checkbox" formControlName="fingerprint" />{{ 'fingerprint' | translate }}</label>
            <label><input type="checkbox" formControlName="contract" />{{ 'Contract' | translate }}</label>
            <label><input type="checkbox" formControlName="authorization" />{{ 'Authorization' | translate }}</label>
          </div>

          <div class="form-group">
            <textarea class="input" formControlName="notes" placeholder="{{ 'note' | translate }}"></textarea>
          </div>

          <div class="form-group">
            <button type="submit" class="fromsave accont" [disabled]="data.invalid">
              @if(isUpdatePage){
              {{ 'Edit' | translate }}

              }
              @else{
              {{ 'Create Client' | translate }}

              }
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>